import { useLinked } from "@linked/react/lib";
import { makeStyles, styled } from "@material-ui/core";
import { Button, Input, PopupDialog, div } from "lqx-react/lib";
import React from "react";
import { TargetFieldCard } from "../../../api/targetFieldCard";
import { DigiSelect } from "../../../components/select";
import { DigiCheckbox, ErrorHighligter } from "../../../shared";
import { GlobalFieldSelectionSection } from "./global-field-selection-section";

export const SingleSelectionPopup = ({ onSigleSelectionApply, onClose, mapping, inBlockMappingFields }
  : { onSigleSelectionApply: any, onClose: any, mapping: { mapFrom: string }, inBlockMappingFields: TargetFieldCard[] }) => {
  const $globalHeader = useLinked(false);
  const $mapTo = useLinked({ id: null, name: '' }).check(x => Boolean(x.id));
  const classes = makeErrorHighlighterStyles();
  const $globalValuePositionMapTo = useLinked({ id: 1, name: 'Below' })


  return (
    <>
      <MapSourceFieldsPopupDialog
        title=''
        actions={
          <>
            <Button disabled={Boolean($mapTo.error)} onClick={() => onSigleSelectionApply($mapTo.value.id, $globalHeader.value, $globalValuePositionMapTo.value.name)}>
              Apply
            </Button>
          </>
        }
        maxWidth='xs'
        hideTitle={true}
        onClose={onClose}
      >
        <Input disabled value={mapping.mapFrom} />
        <InBlockFieldLabel>Field</InBlockFieldLabel>
        <ErrorHighligter error={$mapTo.error} classes={classes}>
          <InBlockFieldSelect lqx-qa-id="inBlockMappingFields" id="id" label="name" $value={$mapTo} options={inBlockMappingFields}></InBlockFieldSelect>
        </ErrorHighligter>

        <DigiCheckbox label="Global Field?" $checked={$globalHeader} />
        {$globalHeader.value ?
          <GlobalFieldSelectionSection $mapTo={$globalValuePositionMapTo}></GlobalFieldSelectionSection> : <></>
        }
      </MapSourceFieldsPopupDialog>
    </>
  );
};

const InBlockFieldLabel = div({
  fontFamily: 'Montserrat',
  fontStyle: 'normal',
  fontWeight: 500,
  fontSize: '13px',
  padding: '4px',
  marginTop: '5px',
  color: '#4197d6'
});

const InBlockFieldSelect = styled(DigiSelect)({
  width: '250px',
  borderRadius: '4px',
  '& .MuiSelect-root': {
    borderRadius: '4px',
  },
  '& .MuiSelect-icon': {
    top: 'calc(50% - 9px)'
  },
});

const MapSourceFieldsPopupDialog = styled(PopupDialog)({
  '& .MuiDialog-paperFullWidth': {
    width: '350px',
  }
});

const makeErrorHighlighterStyles = makeStyles({
  root: {
    border: '2px solid #ffdf71 !important',
    paddingLeft: '5px',
    borderRadius: '10px',
    paddingRight: '5px',
    height: '42px',
    '& [class*="-control"]': {
      border: 'none !important'
    }
  },
});
